import { useState } from "react";
import { getRandomExcept, isFuture } from "shelving";
import { CREATE_MESSAGE } from "shared/api";
import { Form, Icon, SubmitButton, TextAreaField, Until } from "shared/react";
import { MESSAGE_FORM_SCHEMA } from "shared/schema";
import { callAPI } from "../util/api.js";
import { useMemberData } from "../util/data.js";
import { useGroupContext } from "./GroupContext.js";

/** Message form is single-line because it only has one field. */
export function MessageForm({ thread = null }: { thread: string | null }): React.ReactElement {
	const [key, setKey] = useState(0);
	const { id: gid } = useGroupContext();
	return (
		<Form
			key={key}
			schema={MESSAGE_FORM_SCHEMA}
			onSubmit={async v => {
				await callAPI(CREATE_MESSAGE, { gid, thread, ...v });
				setKey(getRandomExcept); // Reset the form by randomly changing the key to anything except its previous number.
			}}
			mods="flex-row"
		>
			<TextAreaField name="content" title="" placeholder="Write message..." />
			<SubmitButton>
				<Icon icon="reply" title="Send message" />
			</SubmitButton>
		</Form>
	);
}

/** Message form with possible "muted until" notice. */
export function PossibleMessageForm(props: Parameters<typeof MessageForm>[0]): React.ReactElement | null {
	const { id: gid } = useGroupContext();
	const { status, muted } = useMemberData(gid);
	if (status === "none") return null;
	return typeof muted === "number" && isFuture(muted) ? (
		<aside className="notice">
			Muted in this group (for <Until target={muted} />)
		</aside>
	) : (
		<MessageForm {...props} />
	);
}
